export class Ticket {

    constructor(
        public id: number = null,
        public po: number = null,
        public rep: any = null,
        public type: string = "out",
        public status: string = "pending",
        public numItemsCompleted: number = 0,
        public comments: string = "",
        public askedLocation: any = null,
        public deadline: string = 'ASAP',
        public indexes: Array<any> = [],
        public notificacion: any = null,
        public indexesScrap: Array<any> = [],
        public returnRequired: boolean = false,
        public hoursReturn: string = '',
        public ticketType: string = 'po',
        public dataItems: string = '',
        public indexesManifest: Array<any> = []
    ) {}
}